import { css } from '@linaria/core';
import { theming } from 'styles/utils';
export const tabGroup = "omponents__Tabs__Tabs_styles_ts-tabGroup-t1yt1ja7";
export const tab = "omponents__Tabs__Tabs_styles_ts-tab-t1xdi44e";
export const active = "omponents__Tabs__Tabs_styles_ts-active-a12oe085";

require("./Tabs.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Tabs.styles.ts");